<app-search/>

<app-toolbar />

<div id="map">
  <app-homes-layer />
  <app-friends-layer />
  <app-favorite-layer />
</div>

<app-banner />

<app-controls/>

<app-legend />

<app-side-panel/>
